import { ViewModel, View, ObservableArray } from "binder"
import { ToolReplacementManipulationView } from "./toolReplacementManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IToolReplacement } from "./IToolReplacement";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ToolStatusSelectorViewModel } from "./selectors/toolStatusSelector-viewModel";
import { ReplacementReasonSelectorViewModel } from "./selectors/replacementReasonMultiSelector";
import { SingleToolSelectorViewModel } from "./selectors/singleToolSelector-viewModel";
import { CurrentCredentials } from "src/server/currentCredentials";

export class ToolReplacementManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف تعویض ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolReplacements = ObservableArray.create<ToolReplacement>();

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolReplacementManipulationView();
    }
    public getTypeId(): string {
        return "VM-C6909B50-54F6-4819-8241-F5EFF9392C5C"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolReplacements(v: ObservableArray<ToolReplacement>) { this._toolReplacements = v; } public get toolReplacements(): ObservableArray<ToolReplacement> { return this._toolReplacements; } private _toolReplacements: ObservableArray<ToolReplacement>;

    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/AllActiveMachinesWithRelatedTools', {});
            this.toolReplacements.update(...result.ActiveMachinesWithRelatedToolsData.map((x, i) => {
                let t = new ToolReplacement(this);
                t.index = i + 1;
                t.machineId = x.MachineId;
                x.RelatedSingleTools.map((y) => {
                    t.singleToolModelId = y.SingleToolModelId;
                    t.singleToolModelName = y.SingleToolModelName;
                    t.currentRemainingLifeTime = y.CurrentRemainingLifeTime;
                    t.lifeTimeAmount = y.LifeTimeAmount;
                    t.additionalTimeBeforeReplacement = y.AdditionalTimeBeforeReplacement;
                });
                x.RelatedToolPlaces.map((y) => {
                    t.toolPlaceId = y.ToolPlaceId;
                    t.toolPlaceName = y.ToolPlaceName;
                    t.toolPlaceCode = y.ToolPlaceCode;
                });
                return t;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async showDetail(toolReplacement: IToolReplacement) {
        let toolReplacementStructure = new ToolReplacementStructureViewModel(this);
        toolReplacement.cloneTo(toolReplacementStructure);
        this.requestShowingPopup(toolReplacementStructure);
    }
}

export class ToolReplacement extends ViewModel implements IToolReplacement {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolReplacementManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolReplacementManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolPlaceId(v: string) { this._toolPlaceId = v; } public get toolPlaceId(): string { return this._toolPlaceId; } private _toolPlaceId: string;
    public set toolPlaceName(v: string) { this._toolPlaceName = v; } public get toolPlaceName(): string { return this._toolPlaceName; } private _toolPlaceName: string;
    public set toolPlaceCode(v: string) { this._toolPlaceCode = v; } public get toolPlaceCode(): string { return this._toolPlaceCode; } private _toolPlaceCode: string;
    public set singleToolModelId(v: string) { this._singleToolId = v; } public get singleToolModelId(): string { return this._singleToolId; } private _singleToolId: string;
    public set singleToolModelName(v: string) { this._singleToolModelName = v; } public get singleToolModelName(): string { return this._singleToolModelName; } private _singleToolModelName: string;
    public set machineId(v: string) { this._machineId = v; } public get machineId(): string { return this._machineId; } private _machineId: string;
    public set currentRemainingLifeTime(v: string) { this._currentRemainingLifeTime = v; } public get currentRemainingLifeTime(): string { return this._currentRemainingLifeTime; } private _currentRemainingLifeTime: string;
    public set lifeTimeAmount(v: string) { this._lifeTimeAmount = v; } public get lifeTimeAmount(): string { return this._lifeTimeAmount; } private _lifeTimeAmount: string;
    public set additionalTimeBeforeReplacement(v: string) { this._additionalTimeBeforeReplacement = v; } public get additionalTimeBeforeReplacement(): string { return this._additionalTimeBeforeReplacement; } private _additionalTimeBeforeReplacement: string;

    setToolStatusId(value: string) {
        throw new Error("Method not implemented.");
    }
    getToolStatusId(): string {
        throw new Error("Method not implemented.");
    }

    setReplacementReasonIds(value: string[]) {
        throw new Error("Method not implemented.");
    }
    getReplacementReasonIds(): string[] {
        throw new Error("Method not implemented.");
    }

    setSingleToolId(value: string) {
        throw new Error("Method not implemented.");
    }
    getSingleToolId(): string {
        throw new Error("Method not implemented.");
    }

    async cloneTo(toolReplacement: IToolReplacement) {
        toolReplacement.id = this.id;
        toolReplacement.machineId = this.machineId;
        toolReplacement.toolPlaceId = this.toolPlaceId;
        toolReplacement.toolPlaceName = this.toolPlaceName;
        toolReplacement.toolPlaceCode = this.toolPlaceCode;
        toolReplacement.singleToolModelId = this.singleToolModelId;
        toolReplacement.singleToolModelName = this.singleToolModelName;
        toolReplacement.currentRemainingLifeTime = this.currentRemainingLifeTime;
        toolReplacement.lifeTimeAmount = this.lifeTimeAmount;
        toolReplacement.additionalTimeBeforeReplacement = this.additionalTimeBeforeReplacement;
        toolReplacement.getToolStatusId();
        toolReplacement.getReplacementReasonIds();
        toolReplacement.getSingleToolId();
    }

    async showDetail() {
        await this._typedParent.showDetail(this);
    }
}

export class ToolReplacementStructureViewModel extends ViewModel implements IToolReplacement {
    public getTypeId(): string { return 'toolreplacement-structure'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.toolStatusSelector = new ToolStatusSelectorViewModel(this);
        this.replacementReasonSelector = new ReplacementReasonSelectorViewModel(this);
        this.singleToolSelector = new SingleToolSelectorViewModel(this);

        this.canReUse = false;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set canReUse(v: boolean) { this._canReUse = v; } public get canReUse(): boolean { return this._canReUse; } private _canReUse: boolean;
    public set toolPlaceId(v: string) { this._toolPlaceId = v; } public get toolPlaceId(): string { return this._toolPlaceId; } private _toolPlaceId: string;
    public set toolPlaceName(v: string) { this._toolPlaceName = v; } public get toolPlaceName(): string { return this._toolPlaceName; } private _toolPlaceName: string;
    public set machineId(v: string) { this._machineId = v; } public get machineId(): string { return this._machineId; } private _machineId: string;
    public set singleToolModelId(v: string) { this._singleToolModelId = v; } public get singleToolModelId(): string { return this._singleToolModelId; } private _singleToolModelId: string;
    public set singleToolModelName(v: string) { this._singleToolModelName = v; } public get singleToolModelName(): string { return this._singleToolModelName; } private _singleToolModelName: string;
    public set toolPlaceCode(v: string) { this._toolPlaceCode = v; } public get toolPlaceCode(): string { return this._toolPlaceCode; } private _toolPlaceCode: string;
    public set currentRemainingLifeTime(v: string) { this._currentRemainingLifeTime = v; } public get currentRemainingLifeTime(): string { return this._currentRemainingLifeTime; } private _currentRemainingLifeTime: string;
    public set lifeTimeAmount(v: string) { this._lifeTimeAmount = v; } public get lifeTimeAmount(): string { return this._lifeTimeAmount; } private _lifeTimeAmount: string;
    public set additionalTimeBeforeReplacement(v: string) { this._additionalTimeBeforeReplacement = v; } public get additionalTimeBeforeReplacement(): string { return this._additionalTimeBeforeReplacement; } private _additionalTimeBeforeReplacement: string;

    public set toolStatusSelector(v: ToolStatusSelectorViewModel) { this._toolStatusSelector = v; } public get toolStatusSelector(): ToolStatusSelectorViewModel { return this._toolStatusSelector; } private _toolStatusSelector: ToolStatusSelectorViewModel;
    public set replacementReasonSelector(v: ReplacementReasonSelectorViewModel) { this._replacementReasonSelector = v; } public get replacementReasonSelector(): ReplacementReasonSelectorViewModel { return this._replacementReasonSelector; } private _replacementReasonSelector: ReplacementReasonSelectorViewModel;
    public set singleToolSelector(v: SingleToolSelectorViewModel) { this._singleToolSelector = v; } public get singleToolSelector(): SingleToolSelectorViewModel { return this._singleToolSelector; } private _singleToolSelector: SingleToolSelectorViewModel;

    setToolStatusId(id: string) {
        this.toolStatusSelector.selectById(id);
    }
    getToolStatusId(): string {
        return this.toolStatusSelector.selectedItem?.id;
    }

    setReplacementReasonIds(value: string[]) {
        this.replacementReasonSelector.selectById(value);
    }
    getReplacementReasonIds(): string[] {
        return this.replacementReasonSelector.selectedItems.map(x => x.id);
    }

    setSingleToolId(id: string) {
        this.singleToolSelector.selectById(id);
    }
    getSingleToolId(): string {
        return this.singleToolSelector.selectedItem?.id;
    }

    closePopup(result: any) {

    }

    back() {
        this.closePopup(null);
    }

    async cloneTo(toolReplacement: IToolReplacement) {
        toolReplacement.id = this.id;
        toolReplacement.machineId = this.machineId;
        toolReplacement.toolPlaceId = this.toolPlaceId;
        toolReplacement.toolPlaceName = this.toolPlaceName;
        toolReplacement.singleToolModelId = this.singleToolModelId;
        toolReplacement.singleToolModelName = this.singleToolModelName;
        toolReplacement.getToolStatusId();
        toolReplacement.getReplacementReasonIds();
        toolReplacement.getSingleToolId();
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت تعویض ابزار');
            return;
        } else {
            try {
                let result = await ServerConnection.callServer('/Complex/ToolInstallationServices/ApplyReplacement', {
                    PersonnelId: CurrentCredentials.personnelId,
                    SingleReplacementItems: [{
                        ToolPlaceHolderId: this.machineId,
                        ToolPlaceId: this.toolPlaceId,
                        NewToolInstalled: this.canReUse ? true : false,
                        UseCurrentTool: this.canReUse ? false : true,
                        NewSingleToolId: this.getSingleToolId(),
                        ValidStatusId: this.canReUse ? null : this.getToolStatusId(),
                        CurrentNewToolStatusId: this.canReUse ? this.getToolStatusId() : null,
                        ReplacementReasonIds: this.getReplacementReasonIds(),
                        ToolModelFromProducerId: null
                    }]
                });
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                } else {
                    await this.messageBoxConfirmSuccess('تعویض ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت تعویض ابزار', 'خطا در عملیات');
                console.log(ex);
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (this.canReUse) {
            if (stringIsNullOrEmpty(this.getToolStatusId())) {
                result.push('وضعیت جدید ابزار مشخص نشده است.');
            }
        }
        else {
            if (stringIsNullOrEmpty(this.getSingleToolId())) {
                result.push('ابزار مشخص نشده است.');
            }
            if (stringIsNullOrEmpty(this.getToolStatusId())) {
                result.push('وضعیت ابزار مشخص نشده است.');
            }
        }
        if (stringIsNullOrEmpty(this.replacementReasonSelector.selectedItems.map(item => item.name).toString())) {
            result.push('علت تعویض مشخص نشده است.');
        }
        return result;
    }
}
